import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Form, Input, Divider, Modal } from "antd";
import userAction from "../../redux/users/actions";
import "./index.css";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState();
  const { getCode, changePassword } = userAction;

  const onFinish = (email) => {
    setEmail(email);
    dispatch(getCode(email));
  };

  const onFinishPassword = (values) => {
    var payload = {
      email: email.email,
      code: values.code,
      password: values.password,
    };
    dispatch(changePassword(payload));
  };

  return (
    <>
      <div className="forgot-password-container">
        <Modal
          title={<div className="forgot-password-title">TouchSale Portal</div>}
          open={true}
          closable={false}
          bodyStyle={{ height: "470px" }}
          className="forgot-password-modal"
          footer={[
            <div
              key="forgot-password-footer"
              className="forgot-password-button"
            >
              <Link to="/signin">Назад към Вход</Link>
            </div>,
          ]}
        >
          <Form name="recover" onFinish={onFinish}>
            <Form.Item
              key="forgot-password-message"
              className="forgot-password-form-item-text"
            >
              <div>
                <h3 className="forgot-password-field-title">
                  Забравена парола?
                </h3>

                <p className="forgot-password-field-description">
                  Въведете вашият имейл и ще Ви изпратим код за възстановяване.
                </p>
              </div>
            </Form.Item>
            <div>
              <Form.Item
                key="forgot-password-message-email"
                className="forgot-password-form-item"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Email е задължителен!",
                  },
                  {
                    min: 2,
                    message: "Email не може да бъде по-кратък от 2 символа!",
                  },
                  {
                    type: "email",
                    message: "Невалиден Email!",
                  },
                ]}
              >
                <Input placeholder="Email" size="large" />
              </Form.Item>
            </div>

            <Form.Item key="forgot-password-submit">
              <div className="forgot-password-button">
                <Button type="primary" htmlType="submit">
                  Изпрати
                </Button>
              </div>
            </Form.Item>
          </Form>
          <Divider style={{ margin: "10px" }} />
          <Form onFinish={onFinishPassword} name="verify" autoComplete="off">
            <Form.Item
              key="forgot-password-code-message"
              className="forgot-password-form-item-text"
            >
              <p className="forgot-password-field-description">
                Въведете код за възстановяване.
              </p>
            </Form.Item>
            <Form.Item
              name="code"
              key="forgot-password-code"
              rules={[{ required: true, message: "Моля, въведете код!" }]}
            >
              <Input size="large" placeholder="Код за потвърждение" />
            </Form.Item>
            <Form.Item
              key="forgot-password-recovery-message"
              className="forgot-password-form-item-text"
            >
              <h3 className="forgot-password-field-title">
                Възстановете парола
              </h3>

              <p className="forgot-password-field-description">
                Въведете нова парола и потвърдете.
              </p>
            </Form.Item>

            <Form.Item
              key="forgot-password-password-recovery"
              className="forgot-password-form-item"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Моля въведете парола!",
                },
                {
                  min: 6,
                  message: "Паролата трябва да бъде минимум 6 символа!",
                },
              ]}
              hasFeedback
            >
              <Input.Password placeholder="Парола" size="large" />
            </Form.Item>

            <Form.Item
              key="forgot-password-repeat-password"
              name="repeatPassword"
              className="forgot-password-form-item"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Моля, потвърдете паролата!",
                },
                {
                  min: 6,
                  message: "Паролата трябва да бъде минимум 6 символа!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }

                    return Promise.reject(new Error("Паролите не съвпадат!"));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Повторете" size="large" />
            </Form.Item>
            <Form.Item key="forgot-password-save">
              <div className="forgot-password-button">
                <Button type="primary" htmlType="submit">
                  Запази
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default ForgotPassword;
